import AxiosBusiness from '@/services/api/business/axios_business'

export default {
  // Billable Instance endpoints
  createBillableInstance: (data) => {
    return AxiosBusiness.post('billable-instance', data)
  },

  updateBillableInstance: (billableInstanceId, data) => {
    return AxiosBusiness.put(`billable-instance/${billableInstanceId}`, data)
  },

  deleteBillableInstance: (billableInstanceId) => {
    return AxiosBusiness.delete(`billable-instance/${billableInstanceId}`)
  },

  getBillableInstance: (billableInstanceId) => {
    return AxiosBusiness.get(`billable-instance/${billableInstanceId}`)
  },

  getBillableInstancesByFormatInstance: (formatInstanceId, params = {}) => {
    return AxiosBusiness.get(`billable-instance/format-instance/${formatInstanceId}`, { params })
  },
}
